import { Box, Link, Icon } from '@nimbus-ds/components';
import { ExternalLinkIcon } from '@nimbus-ds/icons';
import { HelpLink } from '@nimbus-ds/patterns';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import { OrderState } from '../../utils';

interface UnderHelpLinkProps {
  orderState: OrderState;
}

export function UnderHelpLink({ orderState }: Readonly<UnderHelpLinkProps>) {
  const t = useTranslationConfigurations('domains.orderDetails');

  if (orderState !== 'success') {
    return null;
  }

  return (
    <Box paddingTop="2">
      <HelpLink>
        <Link
          as="a"
          href="https://ayuda.tiendanube.com/es_MX/175782-abc-del-dominio-propio/preguntas-frecuentes-sobre-la-compra-de-dominios-en-tiendanube"
          target="_blank"
          appearance="primary"
          textDecoration="none"
        >
          {t('underHelpLink')}
          <Icon source={<ExternalLinkIcon />} color="currentColor" />
        </Link>
      </HelpLink>
    </Box>
  );
}
